import React from 'react';

/**
 * Bootstrap switch for admin boolean settings (on/off).
 */
export default function AdminToggle({
  id,
  label,
  checked,
  onChange,
  disabled = false,
  className = '',
  labelClassName = 'small',
  description,
}) {
  return (
    <div className={`form-check form-switch admin-toggle mb-0${className ? ` ${className}` : ''}`}>
      <input
        className="form-check-input"
        type="checkbox"
        role="switch"
        id={id}
        checked={Boolean(checked)}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label className={`form-check-label${labelClassName ? ` ${labelClassName}` : ''}`} htmlFor={id}>
        {label}
      </label>
      {description ? <p className="small text-muted mb-0 mt-1">{description}</p> : null}
    </div>
  );
}

